module.exports = __webpack_public_path__ + "img/logo-full-vertical-cropped-400.8089ab8a.png";